import { render, staticRenderFns } from "./EmployeeComplianceReminderHelpDialog.vue?vue&type=template&id=2b25cb43&"
import script from "./EmployeeComplianceReminderHelpDialog.vue?vue&type=script&lang=js&"
export * from "./EmployeeComplianceReminderHelpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports